import * as ActionTypes from '../../../constants';
import { generateProjectName } from '../../../utils/generateRandomName';

const initialState = () => {
  const generatedString = generateProjectName();
  const generatedName =
    generatedString.charAt(0).toUpperCase() + generatedString.slice(1);
  return {
    name: generatedName,
    updatedAt: '',
    isSaving: false,
    visibility: 'Public'
  };
};

const project = (state, action) => {
  if (state === undefined) {
    state = initialState(); // eslint-disable-line
  }
  switch (action.type) {
    case ActionTypes.SET_PROJECT_NAME:
      return Object.assign({}, { ...state }, { name: action.name });
    case ActionTypes.SET_PROJECT_VISIBILITY:
      return Object.assign(
        {},
        { ...state },
        { visibility: action.visibility, updatedAt: action.updatedAt }
      );
    case ActionTypes.NEW_PROJECT:
      return {
        id: action.project.id,
        name: action.project.name,
        updatedAt: action.project.updatedAt,
        owner: action.owner,
        isSaving: false,
        visibility: action.project.visibility
      };
    case ActionTypes.SET_PROJECT:
      return {
        id: action.project.id,
        name: action.project.name,
        updatedAt: action.project.updatedAt,
        owner: action.owner,
        isSaving: false,
        visibility: action.project.visibility
      };
    case ActionTypes.RESET_PROJECT:
      return initialState();
    case ActionTypes.SET_PROJECT_SAVED_TIME:
      return Object.assign({}, state, { updatedAt: action.value });
    case ActionTypes.START_SAVING_PROJECT:
      return Object.assign({}, state, { isSaving: true });
    case ActionTypes.END_SAVING_PROJECT:
      return Object.assign({}, state, { isSaving: false });
    default:
      return state;
  }
};

export default project;
